<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'SupplierList' }">Suppliers</el-breadcrumb-item>
            <el-breadcrumb-item>Add</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form 
     ref="supplier" 
     :rules="rules.supplier"
     :model="supplier"
     :label-position="label_position">
   
      <el-form-item label="Name" prop="name">
          <el-input v-model="supplier.name"></el-input>
      </el-form-item>

      <el-form-item label="Order Notification E-Mail" prop="order_notification_email">
          <el-input v-model="supplier.order_notification_email"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="addSupplier('supplier')">Add Supplier</el-button>
      </el-form-item>

    </el-form>

  </div>
</template>

<style>
</style>

<script>
  import Config from '@/store/Config.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';

  export default {
    data: function() {
      return {
        config: Config.config,
        page_alias: 'Add Supplier',
        page_slug: 'add-supplier',
        label_position: 'top',
        rules:{
          supplier:{
            name: [
              { required: true, message: 'Please Enter Name', trigger: 'blur' }
            ],

            order_notification_email: [
              { required: true, message: 'Please Enter Order Notification E-Mail', trigger: 'blur' },
              { type: 'email', message: 'Please Enter Valid E-Mail', trigger: 'blur'}
            ],
          }
        },
        supplier: {
          name: '',
          order_notification_email: '',
          created_user_id: '',
          updated_user_id: ''
        }
      };
    },

    mounted: function() {
      const me = this;
    },

    methods: {
      addSupplier: function(formName) {
        console.log('add supplier function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            var jwt = Utils.decodejwt();
            me.supplier.updated_user_id = jwt.sub;
            me.supplier.created_user_id = jwt.sub;
            me.$http.post(me.config.api + 'supplier', me.supplier).then(
            response => {
              console.log('success putting data')  
              console.log(response.status);
              console.log(response.statusText);
              me.$notify({
                title: 'Success',
                message: 'The Supplier Was Added',
                type: 'success'
              });
              me.$router.push({name: 'SupplierList'});
            }, response => {
              console.log('Error Getting Data');
              console.log(response.status);
              console.log(response.statusText);
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/suppliers/SupplierAdd.vue